import Photo from "@components/new/Photo";
import { TableRowType, TableCellLink, TableColumn } from "@components/new/Table";
import {
  isWbRequestItem,
  isUnknownRequestItem,
} from "@api/apiClient/fbp";
// import MatchingSelect from "./MatchingSelect";
import { TLinkRow } from "./types";
import emptyImg from '@assets/img/empty.png';
// import StoreIcon from "@assets/icons/outline/store.svg?react";
import styles from './Form.module.scss';

function getMatchingColumns(
  t: (v: string) => string,
  // sellerWarehouseId: string,
  // items: TLinkRow[],
  // setItems: ((v: TLinkRow[] | ((v: TLinkRow[]) => TLinkRow[])) => void),
): TableColumn<TLinkRow>[] {
  return [
    {
      header: t("fbpPage.delStoreModal.columns.photo"),
      renderCell: (row: TableRowType<TLinkRow>) => (
        isUnknownRequestItem(row.data) ? (
          <img src={emptyImg} alt="" className={styles.emptyImage} />
        ) : (
          <Photo src={row.data.primaryImage} />
        )
      ),
      width: "80px",
      fixWidth: true,
    },
    {
      header: t("fbpPage.delStoreModal.columns.name"),
      renderCell: (row: TableRowType<TLinkRow>) => {
        const description = isWbRequestItem(row.data) ? row.data.wbNmId : row.data.sku;
        return (
          <TableCellLink
            title={row.data.name}
            description={description}
            to={row.data.url}
            external
            maxWidth="460px"
          />
        )
      },
      width: "400px",
    },
    {
      header: t("fbpPage.delStoreModal.columns.newLink"),
      renderCell: (row: TableRowType<TLinkRow>) => {
        /* return (
          <MatchingSelect
            onChange={() => { }}
            sellerWarehouseId={sellerWarehouseId}
          />
        ); */
        return row.data.primaryImage;
      },
      width: "400px",
    },
  ]
}

export default getMatchingColumns
